/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoLight } from "~/foundation/Components/Logo";

export const getDarkColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Dark",
	colors: {
		ribbon: {
			bg: "elementsBackgroundColors.dark",
			color: "primary.white",
			border: "primary.aramcoGrey",
			linkColor: "primary.white"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue"
		},
		header: {
			bg: "elementsBackgroundColors.dark",
			bgInactive: "navigationColors.darkBgTransparent",
			color: "primary.neutralGrey",
			activeColor: "primary.aramcoBlue",
			hygieneColor: "primary.neutralGrey",
			hygieneGlobalContacts: "primary.neutralGrey",
			burgerMenuColor: "primary.white"
		},
		siteNavigation: {
			gradient: "siteNavigation.darkTheme.gradient",
			bg: "siteNavigation.darkTheme.bg",
			color: "siteNavigation.darkTheme.color",
		},
		footer: {
			bg: "gradients.footerDark",
			color: "primary.white"
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.darkTheme.linkColor",
			activeColor: "aramcoBreadcrumb.darkTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.darkTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.darkTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.darkTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.darkGrey",
			color: "primary.white",
			linkColor: "primary.aramcoBlue"
		},
		tags: {
			color: "primary.neutralGrey"
		},
		switch: {
			color: "primary.white",
		}
	},
	Logo: () => <LogoLight height={25} />,
	FooterLogo: () => <LogoLight height={29} />
});